/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import { UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { useSelector } from 'react-redux';
import { closeMultiUpload } from '../../../store/workspaces/modals/actions';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { useTranslation } from 'react-i18next';
import { WidgetContainerStyled, WidgetLabelStyled } from '../styles';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { getSettings } from './services/getSettings';
import { getUploaderButtons } from './services/getUploaderButtons';
import { getAllowedExtensions } from './services/getAllowedExtensions';
import { created } from './services/created';
import { onActionComplete } from './services/actionComplete';
import { onUploading } from './services/uploading';
import { onFailure } from './services/onFailure';
import { onSelectFile } from './services/selectFile';
import { onRemoveFile } from './services/removeFile';
import { log } from '../../../utils/notification';
import store from '../../../store/store';
import './styles.css';


const UploaderWidget: React.FC<any> = () => {

  const modalStates = useSelector((state: any) => state.workspaces.instances.find(instance => instance.isActive).modals);
  const actionsState = useSelector((state: any) => state.workspaces.instances.find(instance => instance.isActive)?.data);
  const { fileTypes } = modalStates.multiUpload.widgetData;
  const dialogRef = useRef<DialogComponent | null>(null);

  const workspaceActions = useSelector((state: any) => state.workspaces.instances.find(instance => instance.isActive)?.data);
  const [uploaderInstance, setUploaderInstance] = useState(null);
  const [files, setFiles] = useState([]);
  const [settings, setSettings] = useState(null);
  const { t } = useTranslation();

  const buttons = getUploaderButtons(setFiles, uploaderInstance, actionsState, modalStates, workspaceActions);
  let dropContainerRef;

  useEffect(() => {
    log(`${modalStates.multiUpload.widgetData.widget} (key: ${modalStates.multiUpload.widgetData.key})`,
      {
        params: { fileTypes: modalStates.multiUpload.widgetData.fileTypes },
        response: { upload: modalStates.multiUpload.widgetData.upload }
      },
      'Widget'
    );

    const getAsyncSettings = async () => {
      try {
        setSettings(await getSettings());
      } catch (error) {
        log('getAsyncSettings', error);
      }
    };

    getAsyncSettings();
  }, []);


  return (
    <WidgetContainerStyled>
      <DialogComponent
        ref={dialogRef}
        visible={modalStates.multiUpload.isOpen}
        width={`${modalStates.multiUpload.widgetData.width}px`}
        height={`${modalStates.multiUpload.widgetData.height}px`}
        showCloseIcon={true}
        isModal
        closeOnEscape={true}
        close={() => {
          store.dispatch(closeMultiUpload({}));
        }}
        target="#root"
        className={'dialog-upload-container'}
      >
        <div className="modal-header">
          {modalStates.multiUpload.widgetData.label && (
            <WidgetLabelStyled>{t(modalStates.multiUpload.widgetData.label)}</WidgetLabelStyled>
          )}

        </div>
        <div style={{ display: 'flex' }}>
          {buttons.map((button) => (
            <ButtonComponent
              id={button.id}
              cssClass={button.cssClass}
              iconCss={button.iconCss}
              content={button?.content}
              style={{ textTransform: 'none', ...button.style }}
              key={button.key}
              onClick={button.onClick}
            />
          ))}
        </div>
        <div className="dialog-upload-preview" ref={dropContainerRef}>
          <span className="e-icons e-plus e-medium" id="dropText" ref={dropContainerRef} />
          <UploaderComponent
            locale={JSON.parse(localStorage.getItem('language'))}
            id='file-upload'
            htmlAttributes={{ name: 'file-upload' }}
            type='file'
            sequentialUpload={true}
            ref={(scope) => setUploaderInstance(scope)}
            autoUpload={false}
            asyncSettings={settings}
            allowedExtensions={getAllowedExtensions(fileTypes)}
            maxFileSize={1024 * 1024 * 1024}
            removing={(args) => onRemoveFile(args, setFiles, files)}
            selected={(args) => onSelectFile(args, fileTypes, modalStates, uploaderInstance, files, setFiles)}
            failure={(args) => onFailure(args)}
            uploading={(args) => onUploading(args, workspaceActions, modalStates)}
            actionComplete={() => onActionComplete(modalStates, workspaceActions)}
            chunkFailure={(args) => {console.log('chunkFailure', args);}}
            pausing={(args) => {console.log('pausing', args);}}
            resuming={(args) => {console.log('resuming', args);}}
            created={() => created(actionsState, uploaderInstance)}
            
            
          />
        </div>
      </DialogComponent>
    </WidgetContainerStyled>
  );
};
export default UploaderWidget;